import { ColDef, DefaultMenuItem, GetMainMenuItems, GetMainMenuItemsParams } from "ag-grid-community";

export const getColDefs = <T>(colDefs: ColDef<T>[], defaultColumnIds: string[], requestShowColumnIds: string[], view?: string): ColDef<T>[] => {
  const colDefsPool = filterAndOrderColDefs(defaultColumnIds, colDefs);

  // requestColumnIds => shown colDefs
  const colDefsShow: ColDef<T>[] = [];
  requestShowColumnIds.forEach((requestShowColumnId) => {
    const colDef = colDefsPool.find((it) => requestShowColumnId === it.colId);
    // do not show group columns that are meant to be hidden
    if (colDef) {
      const isHiddenGroupColumn = colDef.rowGroup === true && colDef.hide === true;
      if (!isHiddenGroupColumn) {
        colDefsShow.push(colDef);
      }
    } else {
      console.warn(`Could not find column ${requestShowColumnId}${view ? ` for "${view}".` : ""}`);
    }
  });

  // hiddenColDefs = colDefs pool - shownColDefs
  const columnIdsShow = colDefsShow.map((it) => it.colId).filter(Boolean) as string[];
  const colDefsHide = colDefsPool.filter((it) => it.colId && !columnIdsShow.includes(it.colId));

  // CWI: show hidden columns first
  return colDefsHide.map((it) => ({ ...it, hide: true })).concat(colDefsShow.map((it) => ({ ...it, hide: false })));
};

const filterAndOrderColDefs = <T>(columnIds: string[], colDefs: ColDef<T>[]): ColDef<T>[] => {
  const colDefLookup: Record<string, [ColDef<T>, number]> = colDefs.reduce<Record<string, [ColDef<T>, number]>>((map, colDef, index) => {
    if (colDef.colId) {
      if (columnIds.includes(colDef.colId)) map[colDef.colId] = [colDef, index];
    } else {
      console.warn("ColDef without colId", colDef);
    }
    return map;
  }, {});

  return Object.keys(colDefLookup).sort((columnId1, columnId2) => {
    const [, columnIndex1] = colDefLookup[columnId1];
    const [, columnIndex2] = colDefLookup[columnId2];
    return columnIndex1 - columnIndex2;
  }).map((columnId) => colDefLookup[columnId][0]);
};

/** Convenience method: drop "resetColumn" from main menu. */
export const getMainMenuItems = <T>(params: GetMainMenuItemsParams<T>): ReturnType<GetMainMenuItems<T>> => {
  return params.defaultItems
    .filter((item) => item !== "resetColumns")
    .reduceRight<DefaultMenuItem[]>((list, currentValue) => {
      if (!(list.length === 0 && currentValue === "separator")) {
        list.push(currentValue);
      }
      return list;
    }, [])
    .reverse();
};
